var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShield = function SvgShield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_18575",
    "data-name": "Group 18575",
    width: 44.115,
    height: 54,
    viewBox: "0 0 44.115 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18573",
    "data-name": "Group 18573",
    transform: "translate(5.113 5.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10928",
    "data-name": "Path 10928",
    d: "M47.123,14.816,30.876,9.362,14.629,14.816S8.794,45.457,30.876,51.9C52.957,45.457,47.123,14.816,47.123,14.816Zm-4.5,8.132L27.818,39.3l-7.83-8.65a1.44,1.44,0,0,1,0-1.894,1.132,1.132,0,0,1,1.714,0l6.115,6.755L40.905,21.055a1.132,1.132,0,0,1,1.714,0A1.439,1.439,0,0,1,42.62,22.948Z",
    transform: "translate(-13.932 -9.362)",
    fill: "#07a3c8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18574",
    "data-name": "Group 18574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10929",
    "data-name": "Path 10929",
    d: "M30.876,57.627l-.14-.039C19.048,54.255,11.708,45.1,9.507,31.114a65.9,65.9,0,0,1,.2-20.225l.067-.342,21.1-6.92,21.1,6.92.066.342a65.912,65.912,0,0,1,.2,20.225C50.045,45.1,42.7,54.254,31.016,57.587ZM10.722,11.472a64.914,64.914,0,0,0-.131,19.475C12.743,44.561,19.567,53.125,30.876,56.4,42.2,53.122,49.02,44.547,51.166,30.915a64.825,64.825,0,0,0-.135-19.443L30.876,4.863Z",
    transform: "translate(-8.819 -3.627)",
    fill: "#07a3c8"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield.9ed76aa3.svg";
export { ForwardRef as ReactComponent };